import React from "react";
import { Hero } from "../components/Hero";
import { Testimonials } from "../components/Testimonials";
import { PricingOffer } from "../components/PricingOffer";
import { ProblemSection } from "../components/ProblemSection";
import { FeatureBlock } from "../components/FeatureBlock";
import { TwoInOne } from "../components/TwoInOne";
import { ProjectCategories } from "../components/ProjectCategories";
import { VisualPlans } from "../components/VisualPlans";
import { TransformableBuilds } from "../components/TransformableBuilds";
import { Volumes } from "../components/Volumes";
import { BonusSection } from "../components/BonusSection";
import { FinalOffer } from "../components/FinalOffer";
import { BuildSteps } from "../components/BuildSteps";
import { ComparisonTable } from "../components/ComparisonTable";
import { DigitalAccess } from "../components/DigitalAccess";
import { Faq } from "../components/Faq";
import { FinalCta } from "../components/FinalCta";
import { ContactForm } from "../components/ContactForm";
import { Footer } from "../components/Footer";
import { confidenceBlock, workshopBlock } from "../data/content";
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-358" data-mp="3pegg8ofg0rg2">
      <div className="bg-brand px-4 py-2.5 text-center font-heading text-xs font-semibold uppercase tracking-wide text-white md:text-base" data-id="element-359" data-mp="3pf9ppx5sdv1w">
        Limited-time September sale: 72% off — build smarter, spend less
      </div>
      <Hero data-id="element-360" data-mp="l2mfur2hccru" />
      <main data-id="element-361" data-mp="gywpbw28vl46">
        <Testimonials data-id="element-362" data-mp="gz6exijdnq9c" />
        <PricingOffer id="offer" data-id="element-363" data-mp="gzzi69j4nxmq" />
        <ProblemSection data-id="element-364" data-mp="h114xb9ia8ka" />
        <FeatureBlock block={confidenceBlock} data-id="element-365" data-mp="c87z0k2awu6m" />
        <TwoInOne data-id="element-366" data-mp="c6wugi117ieg" />
        <FeatureBlock block={workshopBlock} data-id="element-367" data-mp="c6dgfcei5e5p" />
        <ProjectCategories data-id="element-368" data-mp="79n0cp2p6ika" />
        <VisualPlans data-id="element-369" data-mp="78bwyqd5zctp" />
        <TransformableBuilds data-id="element-370" data-mp="78v55fd0imuj" />
        <Volumes data-id="element-371" data-mp="14o8xcslu5n4w" />
        <BonusSection data-id="element-372" data-mp="14or2keqh7boy" />
        <FinalOffer id="offer-2" data-id="element-373" data-mp="14pakhvg4m02z" />
        <BuildSteps data-id="element-374" data-mp="14qbxw6km6ynv" />
        <ComparisonTable data-id="element-375" data-mp="zy2aax6z2aor" />
        <DigitalAccess data-id="element-376" data-mp="zwr7p0p9j8z8" />
        <Faq data-id="element-377" data-mp="zw7m9a0em2gg" />
        <FinalCta data-id="element-378" data-mp="zvplq16pl22q" />
        <ContactForm data-id="element-379" data-mp="1iu13zutxdvih" />
      </main>
      <Footer data-id="element-380" data-mp="1iv2he5yeyu3d" />
    </div>;
}